import {
  Component,
  ElementRef,
  NgZone,
  OnDestroy,
  ViewChild,
  ViewRef,
} from "@angular/core";
import {
  HsLayoutService,
  HsQueryBaseService,
  HsLanguageService,
  HsEventBusService,
  HsDialogContainerService,
  HsUtilsService,
} from "hslayers-ng";
import { StrategyBaseChartsService } from "./strategy-base-charts.service";
import { AppService } from "../app.service";
import { ChartFocusComponent } from "../charts/chart-focus/chart-focus.component";
import { ChartsService } from "../charts/charts.service";
import { StrategyClimaService } from "./strategy-clima.service";
import { StrategyCommonService } from "./strategy-common.service";

@Component({
  selector: "strategy",
  templateUrl: "./strategy.component.html",
  styleUrls: ["./strategy.component.scss"],
})
export class AcStrategyComponent implements OnDestroy {
  viewRef: ViewRef;
  data: {};

  overviewTypes = [
    {
      title: "Place overview",
      value: "place",
    },
    {
      title: "Crop overview",
      value: "crop",
    },
  ];

  cropsExpanded = false;
  chartZoomSubscription;
  loaderImage;
  lang;

  constructor(
    public AppService: AppService,
    public HsLayoutService: HsLayoutService,
    private HsQueryBaseService: HsQueryBaseService,
    public StrategyBaseChartsService: StrategyBaseChartsService,
    public HsLanguageService: HsLanguageService,
    elementRef: ElementRef,
    public ChartsService: ChartsService,
    public HsEventBusService: HsEventBusService,
    public HsDialogContainerService: HsDialogContainerService,
    public hsUtilsService: HsUtilsService,
    public StrategyClimaService: StrategyClimaService,
    public StrategyCommonService: StrategyCommonService,
    private zone: NgZone
  ) {
    this.StrategyBaseChartsService.dialogElement = elementRef;

    this.loaderImage =
      this.hsUtilsService.getAssetsPath() + "img/ajax-loader.gif";

    this.chartZoomSubscription = this.ChartsService.chartClicked.subscribe(
      (data) => {
        this.zone.run(() => {
          if (this.StrategyBaseChartsService.zoom) {
            this.zoomToChart(data);
          }
        });
      }
    );

    //TODO: SHOULD BE BETTER TO HAVE SPECIFIC SUBJECT ON HSL SIDE
    this.HsEventBusService.mainPanelChanges.subscribe((which) => {
      if (which === "strategy") {
        if (this.lang != this.HsLanguageService.language) {
          this.StrategyCommonService.fetchAndRender(
            this.StrategyCommonService.selectedCoords
          );
        }
        this.lang = this.HsLanguageService.language;
      }
    });
  }

  ngOnDestroy() {
    this.chartZoomSubscription.unsubscribe();
  }

  overviewSelected(type: string) {
    this.StrategyCommonService.overviewSelected(type);
  }

  cropSelected(crop) {
    this.StrategyCommonService.selectedCrop = crop;
    this.cropsExpanded = false;
    this.AppService.updateLayerParams.next({
      crop: crop,
    });
    this.StrategyCommonService.fetchAndRender(
      this.StrategyCommonService.selectedCoords
    );
  }

  seasonStartDateSelected(e) {
    if (e.year !== this.StrategyCommonService.selectedDate.upper) {
      this.StrategyCommonService.selectedDate.upper = e.year;
      this.AppService.currentDateIndexUpper = this.AppService.dateRange.indexOf(
        `${e.year}-01-01T00:00:00.000Z`
      );
      this.AppService.updateLayerParams.next({
        year: e.year,
      });
    }
    this.StrategyCommonService.fetchAndRender(
      this.StrategyCommonService.selectedCoords
    );
  }

  uncertainityToggled() {
    this.StrategyCommonService.uncertainity =
      !this.StrategyCommonService.uncertainity;
    this.ChartsService.generatingCharts = true;
    this.StrategyCommonService.renderCharts$.next();
    setTimeout(() => {
      this.ChartsService.generatingCharts = false;
      this.StrategyCommonService.climaDataLoading = false;
      this.StrategyCommonService.baseChartsLoading = false;
    }, 500);
  }

  toggleChartZoom() {
    this.StrategyBaseChartsService.zoom = !this.StrategyBaseChartsService.zoom;
    document.querySelector<HTMLElement>(".chart-wrapper").style.cursor = this
      .StrategyBaseChartsService.zoom
      ? "pointer"
      : "default";
  }

  zoomToChart(data) {
    this.HsDialogContainerService.create(ChartFocusComponent, data);
  }

  isVisible() {
    return this.HsLayoutService.mainpanel == "strategy";
  }

  renderCharts() {
    this.HsLayoutService.setMainPanel("strategy");
    this.StrategyCommonService.fetchAndRender(
      this.HsQueryBaseService.data.coordinates[0].epsg4326Coordinate
    );
  }
}
